import { PaginationRequestModel } from "@/models";

export default class GetTasksListMonitoringDaysRequesModel {
  Page: PaginationRequestModel;
  SelectedPerformerId: number[];
  SelectDateStart?: Date;
  SelectDateEnd?: Date;

  constructor(obj?: GetTasksListMonitoringDaysRequesModel) {
    if (obj) Object.assign(this, obj);
  }
}
